import { Heart } from 'lucide-react';
import { useFavoriteStatus } from '../arches/favorites/hooks/useFavoriteStatus';

interface FavoriteButtonProps {
  archeId: string;
  className?: string;
}

// Arches that should not be favoritable (navigation-level, not user-facing tools)
const NON_FAVORITABLE = new Set(['arche_favorites', 'arche_make_a_request']);

/**
 * Heart icon toggle button for favoriting/unfavoriting an arche.
 * Uses optimistic UI — the heart fills/unfills immediately on click.
 */
export function FavoriteButton({ archeId, className = '' }: FavoriteButtonProps) {
  const { isFavorite, isLoading, toggle } = useFavoriteStatus(archeId);

  if (NON_FAVORITABLE.has(archeId)) {
    return null;
  }

  if (isLoading) {
    return (
      <button
        disabled
        className={`text-muted-foreground transition-colors ${className}`}
        title="Loading..."
      >
        <Heart className="h-5 w-5" />
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      }}
      className={`transition-colors hover:text-red-500 ${
        isFavorite ? 'text-red-500' : 'text-muted-foreground'
      } ${className}`}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Heart className={`h-5 w-5 ${isFavorite ? 'fill-current' : ''}`} />
    </button>
  );
}
